import baseUrl from './base';

export const getRegies = ({ page } = { page: 1 }) => `${baseUrl}/regies?page=${page}`;
export const getRegieRegisseurs = ({ identifiantRegie, page = 1 }) =>
  `${baseUrl}/regies/${identifiantRegie}/regisseurs?page=${page}`;
export const getRegieModesReglement = ({ identifiantRegie }) =>
  `${baseUrl}/regies/${identifiantRegie}/modesReglements`;
export const getRegieEncaisse = (identifiantRegie) =>
  `${baseUrl}/regies/${identifiantRegie}/encaisse`;

// Sans id regie ou regisseur, ils doivent être dans les headers
export const getRegieIndicateurs = () => `${baseUrl}/indicateurs-cle`;

export const getUtilisateurRegies = (idLogin) =>
  `${baseUrl}/regies?perPage=50${idLogin ? `&identifiantLogin=${idLogin}` : ''}`;

export const getRegie = (id: number) => `${baseUrl}/regies/${id}`;
export const putRegie = (id: number) => `${baseUrl}/regies/${id}`;
export const deleteRegie = (id: number) => `${baseUrl}/regies/${id}`;

export const postRegieProduction = (id: number) => `${baseUrl}/regies/${id}/production`;

export const deleteLogoRegie = (idRegie: number) => `${baseUrl}/regies/${idRegie}/logo`;

export const getRegiesCheckLimit = () => `${baseUrl}/regies/check-limit`;

// Déclenchement de l'interrogation des paiements MFO de la régie courante (en-tête X-Regie).
export const postInterrogationPaiementsMfo = () => `${baseUrl}/paiements-mfo/interrogation`;
